import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/home/HomeContainer.vue";
import Record from "@/views/Record.vue";
import OptionalSignUp from "@/views/OptionalSignUp.vue";
import PersonalDataForm from "@/views/PersonalDataForm.vue";
import SignUp from "@/views/SignUp.vue";
import SignIn from "@/views/SignIn.vue";
import Upload from "@/views/Upload.vue";
import Success from "@/views/Success.vue";
import ForgetPassword from "@/views/ForgetPassword.vue";

// Use this if do not want lazy loading
// import AR from "@/views/AR.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/record",
        name: "Record",
        component: Record
    },
    {
        path: "/optional-signup",
        name: "OptionalSignUp",
        component: OptionalSignUp
    },
    {
        path: "/user-data",
        name: "UserDataForm",
        component: PersonalDataForm
    },
    {
        path: "/signup",
        name: "SignUp",
        component: SignUp
    },
    {
        path: "/signin",
        name: "SignIn",
        component: SignIn
    },
    {
        path: "/forgetPassword",
        name: "ForgetPassword",
        component: ForgetPassword
    },
    {
        path: "/upload",
        name: "Upload",
        component: Upload
    },
    {
        path: "/success",
        name: "Success",
        component: Success
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
